// Real content-change dates, shared by `app/sitemap.ts` (lastmod) and the
// page-level schema (`dateModified`) so freshness signals never disagree.
//
// Bump the relevant constant ONLY when that page's actual content changes — not
// on every deploy. Honest lastmod/dateModified is a real freshness signal that
// Google and AI answer engines reward; a build-time `new Date()` teaches them to
// ignore it.
export const LANDING_UPDATED = new Date("2026-07-16"); // home + country variants
export const COMPARISON_UPDATED = new Date("2026-07-16"); // /vs/* pages
export const DIRECTORY_UPDATED = new Date("2026-08-12"); // /directory/* programmatic pages (bump when the allow-list is regenerated)
export const LEGAL_UPDATED = new Date("2026-05-01"); // /terms, /privacy
export const HONESTY_UPDATED = new Date("2026-07-22"); // /data-honesty
export const CONTACT_UPDATED = new Date("2026-08-18"); // /contact
export const AFFILIATE_UPDATED = new Date("2026-08-08"); // /affiliates (bump when the programme terms change)

/** ISO date (YYYY-MM-DD) for schema.org `dateModified`. */
export const asIsoDate = (d: Date): string => d.toISOString().slice(0, 10);
